import { useEffect, useState } from 'react';

const visibleMs = 1800;

/**
 * Drives `SavedIndicator`: `markSaved` shows it for a moment. Call
 * `clearSaved` before each new attempt so an earlier success never sits next
 * to the failure of the latest change.
 */
export function useSavedFlash() {
  const [savedAt, setSavedAt] = useState<number | null>(null);

  useEffect(() => {
    if (savedAt === null) return;
    const timer = window.setTimeout(() => setSavedAt(null), visibleMs);
    return () => window.clearTimeout(timer);
  }, [savedAt]);

  return {
    isSaved: savedAt !== null,
    markSaved: () => setSavedAt(Date.now()),
    clearSaved: () => setSavedAt(null),
  };
}
